import React, { useState } from 'react';
import { Dialog, Grid, Button, Typography, DialogContent, TextField } from '@mui/material';
import { ActivityInterface, useActivitiesContext } from 'pages/Activities/activities.context';
import Comment from '@mui/icons-material/Comment';
import CustomIcon from 'components/Icon/CustomIcon';
import { forceFocus } from './utils';

const CommentOnActivity = ({ activity, text }: { activity: ActivityInterface; text?: string }) => {
  const [showCommentDialog, setShowCommentDialog] = useState(false);
  const [comment, setComment] = useState('');
  const { createCommentOnActivity } = useActivitiesContext();

  const handleCommentOnActivity = async () => {
    await createCommentOnActivity(activity, comment);
    setShowCommentDialog(false);
  };

  return (
    <>
      <CustomIcon onClick={() => setShowCommentDialog(true)} label={text} icon={<Comment />} />
      <Dialog open={showCommentDialog} onClose={() => setShowCommentDialog(false)}>
        <Grid container textAlign='center' p={2}>
          <Grid item xs={12}>
            <Typography variant='h5'>Comment on Activity</Typography>
            Recipients will receive a link to this task.
          </Grid>
          <Grid item xs={12}>
            <DialogContent>
              <TextField
                inputRef={forceFocus}
                margin='dense'
                id='comment'
                label='Comment'
                placeholder='Enter your comment here...'
                type='text'
                fullWidth
                defaultValue=''
                multiline={true}
                minRows='2'
                onChange={(e) => {
                  setComment(e.target.value);
                }}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
              />
            </DialogContent>
          </Grid>
          <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', gap: '10px' }}>
            <Button
              onClick={() => setShowCommentDialog(false)}
              sx={{
                padding: '7px 18px',
                width: '89px',
                height: '36px',
                borderRadius: '10px',
                border: '0.75px solid #0E0C19',
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleCommentOnActivity()}
              sx={{
                padding: '7px 18px',
                width: '89px',
                height: '36px',
                background: '#0E0C19',
                borderRadius: '10px',
                color: '#FFFFFF',
              }}
            >
              Comment
            </Button>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default CommentOnActivity;
